import * as types from './types';

const INITIAL_STATE = {
  getData: {
    loading: false,
    errors: null,
  },

  // Configuration
  getConfiguration: {
    loading: false,
    data: null,
    errors: null,
  },
  postGetLeaInfoRefIds: {
    loading: false,
    data: null,
    errors: null,
  },
  postTestConnection: {
    loading: false,
    data: null,
    errors: null,
  },
  setConfiguration: {
    loading: false,
    data: null,
    errors: null,
  },

  // Mapping
  getMappings: {
    loading: false,
    data: null,
    errors: null,
  },
  getSites: {
    loading: false,
    data: null,
    errors: null,
  },
  getGrades: {
    loading: false,
    data: null,
    errors: null,
  },
  setMappings: {
    loading: false,
    data: null,
    errors: null,
  },

  // Preview
  preview: {
    data: null,
    errors: null,
    loading: false,
    beenRun: false,
    success: false,
    studentId: null,
  },
  importStudent: {
    data: null,
    errors: null,
    success: false,
    loading: false,
  },

  // Import
  bulkImport: {
    errors: null,
    loading: false,
    isComplete: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.VENDORLINK_GETDATA_LOADING: {
      const { getData } = state;
      return { ...state, getData: { ...getData, loading: action.payload } };
    }
    case types.VENDORLINK_GETDATA_ERROR: {
      const { getData } = state;
      return { ...state, getData: { ...getData, errors: action.payload } };
    }

    // Config Cases
    case types.VENDORLINK_GETCONFIGURATION_LOADING: {
      const { getConfiguration } = state;
      return {
        ...state,
        getConfiguration: { ...getConfiguration, loading: action.payload },
      };
    }
    case types.VENDORLINK_GETCONFIGURATION_SUCCESS: {
      const { getConfiguration } = state;
      return {
        ...state,
        getConfiguration: { ...getConfiguration, data: action.payload },
      };
    }
    case types.VENDORLINK_GETCONFIGURATION_ERROR: {
      const { getConfiguration } = state;
      return {
        ...state,
        getConfiguration: { ...getConfiguration, errors: action.payload },
      };
    }

    case types.VENDORLINK_POSTGETLEAINFOREFIDS_LOADING: {
      const { postGetLeaInfoRefIds } = state;
      return {
        ...state,
        postGetLeaInfoRefIds: {
          ...postGetLeaInfoRefIds,
          loading: action.payload,
        },
      };
    }
    case types.VENDORLINK_POSTGETLEAINFOREFIDS_SUCCESS: {
      const { postGetLeaInfoRefIds } = state;
      return {
        ...state,
        postGetLeaInfoRefIds: { ...postGetLeaInfoRefIds, data: action.payload },
      };
    }
    case types.VENDORLINK_POSTGETLEAINFOREFIDS_ERROR: {
      const { postGetLeaInfoRefIds } = state;
      return {
        ...state,
        postGetLeaInfoRefIds: {
          ...postGetLeaInfoRefIds,
          errors: action.payload,
        },
      };
    }

    case types.VENDORLINK_POSTTESTCONNECTION_LOADING: {
      const { postTestConnection } = state;
      return {
        ...state,
        postTestConnection: { ...postTestConnection, loading: action.payload },
      };
    }
    case types.VENDORLINK_POSTTESTCONNECTION_SUCCESS: {
      const { postTestConnection } = state;
      return {
        ...state,
        postTestConnection: { ...postTestConnection, data: action.payload },
      };
    }
    case types.VENDORLINK_POSTTESTCONNECTION_ERROR: {
      const { postTestConnection } = state;
      return {
        ...state,
        postTestConnection: { ...postTestConnection, errors: action.payload },
      };
    }

    case types.VENDORLINK_SETCONFIGURATION_LOADING: {
      const { setConfiguration } = state;
      return {
        ...state,
        setConfiguration: { ...setConfiguration, loading: action.payload },
      };
    }
    case types.VENDORLINK_SETCONFIGURATION_SUCCESS: {
      const { setConfiguration } = state;
      return {
        ...state,
        setConfiguration: { ...setConfiguration, data: action.payload },
      };
    }
    case types.VENDORLINK_SETCONFIGURATION_ERROR: {
      const { setConfiguration } = state;
      return {
        ...state,
        setConfiguration: { ...setConfiguration, errors: action.payload },
      };
    }

    // Mapping Cases
    case types.VENDORLINK_GETMAPPINGS_LOADING: {
      const { getMappings } = state;
      return {
        ...state,
        getMappings: { ...getMappings, loading: action.payload },
      };
    }
    case types.VENDORLINK_GETMAPPINGS_SUCCESS: {
      const { getMappings } = state;
      return {
        ...state,
        getMappings: { ...getMappings, data: action.payload },
      };
    }
    case types.VENDORLINK_GETMAPPINGS_ERROR: {
      const { getMappings } = state;
      return {
        ...state,
        getMappings: { ...getMappings, errors: action.payload },
      };
    }

    case types.VENDORLINK_GETSITES_LOADING: {
      const { getSites } = state;
      return {
        ...state,
        getSites: { ...getSites, loading: action.payload },
      };
    }
    case types.VENDORLINK_GETSITES_SUCCESS: {
      const { getSites } = state;
      return {
        ...state,
        getSites: { ...getSites, data: action.payload },
      };
    }
    case types.VENDORLINK_GETSITES_ERROR: {
      const { getSites } = state;
      return {
        ...state,
        getSites: { ...getSites, errors: action.payload },
      };
    }

    case types.VENDORLINK_GETGRADES_LOADING: {
      const { getGrades } = state;
      return {
        ...state,
        getGrades: { ...getGrades, loading: action.payload },
      };
    }
    case types.VENDORLINK_GETGRADES_SUCCESS: {
      const { getGrades } = state;
      return {
        ...state,
        getGrades: { ...getGrades, data: action.payload },
      };
    }
    case types.VENDORLINK_GETGRADES_ERROR: {
      const { getGrades } = state;
      return {
        ...state,
        getGrades: { ...getGrades, errors: action.payload },
      };
    }

    case types.VENDORLINK_SETMAPPINGS_LOADING: {
      const { setMappings } = state;
      return {
        ...state,
        setMappings: { ...setMappings, loading: action.payload },
      };
    }
    case types.VENDORLINK_SETMAPPINGS_SUCCESS: {
      const { setMappings } = state;
      return {
        ...state,
        setMappings: { ...setMappings, data: action.payload },
      };
    }
    case types.VENDORLINK_SETMAPPINGS_ERROR: {
      const { setMappings } = state;
      return {
        ...state,
        setMappings: { ...setMappings, errors: action.payload },
      };
    }

    // Preview Cases
    case types.VENDORLINK_PREVIEW_LOADING: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, loading: action.payload },
      };
    }
    case types.VENDORLINK_PREVIEW_SUCCESS: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, data: action.payload, success: true },
      };
    }
    case types.VENDORLINK_PREVIEW_ERROR: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, errors: action.payload },
      };
    }
    case types.VENDORLINK_PREVIEW_SET_ID: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, studentId: action.payload },
      };
    }
    case types.VENDORLINK_PREVIEW_CLEAR_DATA: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, data: null },
      };
    }
    case types.VENDORLINK_PREVIEW_CLEAR_ERRORS: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, errors: null },
      };
    }
    case types.VENDORLINK_PREVIEW_CLEAR_SUCCESS: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, success: false },
      };
    }
    case types.VENDORLINK_PREVIEW_RAN: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, beenRun: action.payload },
      };
    }
    case types.VENDORLINK_PREVIEW_UPDATE_SUCCESS: {
      const { preview } = state;
      return {
        ...state,
        preview: { ...preview, success: action.payload },
      };
    }

    // Single Import Cases
    case types.VENDORLINK_IMPORT_STUDENT_LOADING: {
      const { importStudent } = state;
      return {
        ...state,
        importStudent: {
          ...importStudent,
          loading: action.payload,
        },
      };
    }
    case types.VENDORLINK_IMPORT_STUDENT_SUCCESS: {
      const { importStudent } = state;
      return {
        ...state,
        importStudent: {
          ...importStudent,
          data: action.payload,
          success: true,
        },
      };
    }
    case types.VENDORLINK_IMPORT_STUDENT_ERROR: {
      const { importStudent } = state;
      return {
        ...state,
        importStudent: { ...importStudent, errors: action.payload },
      };
    }
    case types.VENDORLINK_IMPORT_STUDENT_CLEAR_ERROR: {
      const { importStudent } = state;
      return {
        ...state,
        importStudent: { ...importStudent, errors: null },
      };
    }
    case types.VENDORLINK_IMPORT_STUDENT_SET_SUCCESS: {
      const { importStudent } = state;
      return {
        ...state,
        importStudent: { ...importStudent, success: action.payload },
      };
    }

    // Bulk Import Cases
    case types.VENDORLINK_BULK_IMPORT_LOADING: {
      const { bulkImport } = state;
      return {
        ...state,
        bulkImport: { ...bulkImport, loading: action.payload },
      };
    }
    case types.VENDORLINK_BULK_IMPORT_ERRORS: {
      const { bulkImport } = state;
      return {
        ...state,
        bulkImport: { ...bulkImport, errors: action.payload },
      };
    }
    case types.VENDORLINK_BULK_IMPORT_COMPLETE: {
      const { bulkImport } = state;
      return {
        ...state,
        bulkImport: { ...bulkImport, isComplete: action.payload },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/state/reducer.js